import styled, { css } from 'styled-components';
import { Heading } from 'components/elements';

// Import utilities
import { flex, media, customMinResponsive } from 'components/styles';

export const AuthenticationContainer = styled.div<{ background: string; filter: boolean }>`
	position: relative;
	overflow: hidden;
	padding: 1rem;
	flex: 1;
	${flex()}
	background-image: url(${({ background }) => background});
	background-attachment: fixed;
	background-position: center top;
	background-repeat: no-repeat;
	background-size: cover;

	${({ filter }) =>
		filter &&
		css`
			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.7);
			}
		`}

	${customMinResponsive(
		900,
		css`
			padding: 0 8% 0 4%;
		`
	)}
`;

export const AuthenticationContent = styled.div`
	z-index: 2;
	flex: 1;
`;

export const StaticStyled = styled.div<{ isUserProfile: boolean }>`
	flex: 1;
	padding: 0 3rem;
	${media.min.min(css`
		padding: 0;
	`)}
	padding-top: ${({ isUserProfile }) => (isUserProfile ? 0 : 3.6)}rem;
	padding-bottom: 5rem;
`;

export const Content = styled.div`
	font-size: 1.4rem;
	color: ${({ theme }) => theme.grayMedium};

	ul {
		padding-left: 4.2rem;
		margin-bottom: 2rem;
	}

	ol {
		padding-left: 4.2rem;
		margin-bottom: 0.9rem;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		color: ${({ theme }) => theme.grayMediumDarkTheme};
	}
`;

export const Wrapper = styled.div`
	position: relative;
	margin-top: 2.9rem;
	min-height: 20rem;
`;

export const HeadingStyled = styled(Heading.First)`
	line-height: 1;
	margin-top: 3rem;
	margin-bottom: 2.4rem;
	text-align: center;
	${media.min.min(css`
		text-align: left;
		margin-top: 8.4rem;
	`)}
`;

export const TvWrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;

	@supports (-moz-appearance: none) {
		height: 100%;
		flex: 1;
	}
`;

export const LoginTemplateHeadline = styled.div`
	flex: 1;
	${flex({ fd: 'column' })}
	text-align: center;
	white-space: pre-line;

	${media.min.large(css`
		${flex({ ai: 'flex-start', fd: 'column' })};
		text-align: left;
	`)}
`;

export const LoginTemplateHeader = styled.p`
	color: ${({ theme }) => theme.white};
	line-height: 1.4;
	font-size: 2.5rem;
	font-weight: ${({ theme }) => theme.font.medium};
	margin-bottom: 1.6rem;

	${media.min.xmin(css`
		font-size: 3.5rem;
	`)}

	${media.min.large(css`
		font-size: 2.5vw;
		margin-bottom: 1.8rem;
	`)}
`;

export const LoginTemplateDescription = styled.p`
	color: ${({ theme }) => theme.white};
	line-height: 1.4;
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: 1.8rem;

	${media.min.large(css`
		font-size: 1.1vw;
	`)}
`;

export const LoginTemplateGrid = styled.div`
	${flex({ fd: 'column' })}

	${media.max.large(css`
		row-gap: 5rem;
		margin-top: 10%;
	`)}

	${media.min.large(css`
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		column-gap: 2%;
	`)}
`;
